import { defineStore } from 'pinia';
import { useRoute, useContext, onMounted } from '@nuxtjs/composition-api';

interface PageState {
  routeData: any;
}

export const routeQuery = `
  query route($url: String!) {
    route(url: $url) {
      type
       ... on ProductInterface {
        sku
      }
      ... on CategoryTree {
        id
        uid
        children {
            uid
            name
        }
        name
      }
      ... on CmsPage {
        identifier
      }
    }
  }
`;

export const usePageResolver = () => {
  const route = useRoute();
  const { app, error, res } = useContext();

  let customName;
  const resolveUrl = async () => {
    let clearUrl = route.value.path
      .replace(/[a-z]+\/[cp|]\//gi, '')
      .replace(`/24orepro`, '');
    const regexp = new RegExp('^\/prodotti\/([^\/]+)\/([^\/]+)\.html$');
    if (regexp.test(clearUrl)) {
      clearUrl = `/prodotti/${clearUrl.match(regexp)?.[1]}.html`
    } else if (clearUrl == '/ultime-novita.html') {
      clearUrl = '/prodotti.html'
      customName = 'Ultime Novità';
    }
    const { data, errors } = await app.$vsf.$magento.api.customQuery({
      query: routeQuery,
      customHeaders: {
        'Cache-Control': 'no-store, no-cache, must-revalidate',
        'Pragma': 'no-cache'
      },
      queryVariables: {
        url: clearUrl
      }
    });

    const results = (data as any)?.route ?? null;


    if (!results || errors?.length) {
      // non chiamare error() che forza la pagina di errore Nuxt.
      // Impostare lo status 404 lato server e restituire un sentinel che le pagine possono gestire.
      if (process.server) {
        try {
          if (res && typeof res.statusCode !== 'undefined') {
            res.statusCode = 404;
          } else if ((app as any).context && (app as any).context.res) {
            (app as any).context.res.statusCode = 404;
          } else if ((app as any).ssrContext && (app as any).ssrContext.res) {
            (app as any).ssrContext.res.statusCode = 404;
          }
        } catch (e) {
          // ignore
        }
      }

      return { type: 'NOT_FOUND', customProps: { error: { statusCode: 404 } } };
    }


    if (results?.type === 'CATEGORY') {
      customName ? results.name = customName : null;
      if (clearUrl.includes('temi-caldi.html')) {
        results.type = 'HOT_TOPICS';
      } else if (clearUrl.includes('/temi-caldi/')) {
        results.type = 'HOT_TOPIC';
      }
    }

    return results;
  };

  return {
    resolveUrl
  };
};

export const usePageStore = defineStore('page', {
  state: (): PageState => ({
    routeData: null,
  }),
});